import { Card, Container, Image } from "semantic-ui-react";
import styles from "./ShopByStyle.module.scss"
import { Heading2 } from "../../../components/value-cssmodules/TextComponent";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const ShopByStyle = () => {
  const intl = useIntl();
  const shopByStyle = [
    {
      id: 1,
      labelId: "home.shopByStyle.female",
      query: "female",
      image: "/photos/women.png",
      objectPosition: "center 55%",
    },
    {
      id: 2,
      labelId: "home.shopByStyle.male",
      query: "male",
      image: "/photos/men.png",
      objectPosition: "center 88%",
    },
    {
      id: 3,
      labelId: "home.shopByStyle.girl",
      query: "girl",
      image: "/photos/girl.png",
      objectPosition: "center 88%",
    },
  ];

  const navigate = useNavigate();

  const handleClick = (query: string) => {
    navigate(`/patterns?clients=${query}`);
  };

  return (
    <Container className={styles.container}>
      <Heading2 className={styles.heading}>
        <FormattedMessage
          id="home.shopByStyle.title"
          defaultMessage="Shop by style"
        />
      </Heading2>
      <div className={styles.grid}>
        {shopByStyle.map((item) => (
          <Card key={item.id} className={styles.card} onClick={() => handleClick(item.query)}>
            <div className={styles.imageWrapper}>
              <Image
                src={item.image}
                alt={intl.formatMessage({ id: item.labelId, defaultMessage: item.query })}
                className={styles.image}
                style={{ objectPosition: item.objectPosition }}
              />

              <div className={styles.overlay}>
                <h2 className={styles.label}>
                  <FormattedMessage
                    id={item.labelId}
                    defaultMessage={item.query}
                  />
                </h2>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </Container>
  )
}

export default ShopByStyle;
